import React from 'react';
import { withInject } from '@piwikpro/platform';
import {
  Text,
  AutoSavedSwitcherControl,
  Stack,
  Card,
  withTranslation,
} from '@piwikpro/ui-components';
import { TrackerSettings, TrackerSettingsAttributes, TrackerSettingsResponse } from '../../../TrackerSettings';
import FailMessage from '../../GlobalAppSettings/FailMessage';

export interface ExcludeCrawlersProps {
  settings: TrackerSettingsResponse
  trackerSettings: TrackerSettings
  failed: boolean
  t: (key: string) => string
}

export class ExcludeCrawlers extends React.Component<ExcludeCrawlersProps> {
  constructor(props: ExcludeCrawlersProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: Partial<TrackerSettingsAttributes>, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: any) {
    const { trackerSettings, settings } = this.props;

    try {
      await trackerSettings.updateSettings(values);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        'exclude_crawlers',
        settings.attributes.exclude_crawlers,
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const { settings, failed, t } = this.props;

    return (
      <Card.Section>
        <Stack wrap verticalAlignment="center">
          <Stack.Item fill>
            <Stack vertical spacing="narrow">
              <Stack.Item>
                <Text as="h2" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">{t('apps.details.settings.tracking.exclude-crawlers.title')}</Text>
              </Stack.Item>
              <Stack.Item>
                <Text as="p">{t('apps.details.settings.tracking.exclude-crawlers.description')}</Text>
              </Stack.Item>
            </Stack>
          </Stack.Item>
          {!failed && (
            <Stack.Item>
              <AutoSavedSwitcherControl
                id="app-settings-tracking-exclude-crawlers"
                initialValue={settings.attributes.exclude_crawlers}
                name="exclude_crawlers"
                onSubmit={this.handleSubmit}
              />
            </Stack.Item>
          )}
        </Stack>
        {failed && <FailMessage condensed />}
      </Card.Section>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
})(withTranslation(['administration'])(ExcludeCrawlers as any));
